import { FieldType } from 'components/Form';
import { FormikValues } from 'formik';
import isEmail from 'validator/lib/isEmail';

import { AuthErrorCodes } from '@lyearn/academy-app/src/@/modules/auth/utils/errorMessage';

export const formInitialValues = {
  email: '',
  password: '',
};

export const formFields = {
  email: {
    name: 'email',
    placeholder: 'Enter your email',
    label: 'Email',
    type: FieldType.Email,
  },
  password: {
    name: 'password',
    placeholder: 'Create a new password',
    label: 'Password',
    type: FieldType.Password,
  },
} as const;

export const formLayout = ['email', 'password'];

export const formValidate = (values: FormikValues) => {
  const errors: any = {};
  if (!values.email) {
    errors.email = 'Please enter your email id.';
  }
  if (values.email && !isEmail(values.email)) {
    errors.email = 'Please enter your correct email id.';
  }
  if (!values.password) {
    errors.password = 'Please enter your password.';
  } else {
    const noNumber = !/\d/.test(values.password);
    const noUpperCase = !/[A-Z]/.test(values.password);
    const noLowerCase = !/[a-z]/.test(values.password);
    const noSpecialChar = !/[^\w*]/.test(values.password);

    if (values.password.length < 8 || noLowerCase || noUpperCase || noNumber || noSpecialChar) {
      errors.password =
        'Password must be at least 8 characters, with at least one number, one uppercase letter, one lowercase letter, and one special character.';
    }
  }

  return errors;
};
